
const filterFunParams = {
//    /v2/excellent/public
 getAvailableModule(res) {
    // /shutdown/availableModule
    if(res.data){
        res.data['isMaintain'] =  res.data['isMaintenance']
        res.data['enableModule'] = res.data['availableModule']
    }
    return res
  },
  getExchangeRate(res) {
    // /common/exchangeRate   
    if(res.data){
        res.data = (res.data||[]).map(i=>{
            i['srcType'] =  res.data['sourceCurrency']
            i['dstType'] = res.data['targetCurrency']
            i['rate'] = res.data['exchangeRate']
            return i
        })
        
    }
    return res
  },
  getUserwealthInfo(res) { 
    // /seckill/user/wealth/info
    if(res.data){
        res.data['id']=res.data['userId']
        res.data['loginName']=res.data['nickName']
        res.data['totalAsset']=res.data['allAmount']
        res.data['totalAssetExchange']=res.data['swapAllAmount']
        res.data['assetRise']=res.data['quoteChange']
        res.data['hasRealValidate']=res.data['realName']
        res.data['hasTradePassword']=res.data['setTradeSecret']
        res.data['vipLevel']=res.data['vipGrade']
        res.data['vipTop']=res.data['isDistinguished']
        res.data['identityType']=res.data['idGenre']
    }
    return res
  },
  getTopsWealthInfo(res){
    // public/seckill/user/wealth/info 新接口
    res.data['id']=res.data['userId']
    res.data['loginName']=res.data['nickName']
    res.data['totalAsset']=res.data['allAmount']
    res.data['totalAssetExchange']=res.data['swapAllAmount']
    res.data['assetRise']=res.data['quoteChange']
    res.data['hasRealValidate']=res.data['realName']
    res.data['hasTradePassword']=res.data['setTradeSecret']
    res.data['vipLevel']=res.data['vipGrade']
    res.data['vipTop']=res.data[' isDistinguished']
    res.data['identityType']=res.data['idGenre']
     return res
   },


   getPublicInsParameter(arr){
    // v2/public/ins 新接口
     arr = (arr||[]).map(i => {
       i.selected = i.beSelected
       i.stopCrossPositionRate = i.crossPositionRate
       i.defaultLeverage = i.defaultLever
       i.takerFee = i.feeRate
       i.leverage = Number(i.lever)
       i.makerFee = i.makerFeeRate
       i.maxLeverage = i.maxLever
       i.minLeverage = i.minLever
       i.settlementRate = i.overNightFee
       i.base = i.instId
       i.name = i.instName
       i.minSize = i.minLot
       i.oneLotMargin=i.lotMargin
       i.configBo = i.config
       i.pricePrecision = i.decimal
       i.stopProfitRate = i.defaultStopProfitRate
       i.oneMaxPosition = i.oneLotMaxPosition
       i.maxPosition = i.positionLimit
       i.commissionRate = i.rebate
       i.settledAt = i.settledTime
       i.defaultStopLossRate = i.stopLossRate
       return i
     });
     return arr
   },
   getLeaderTransactionDataParameter(res){
    // v2/public/ins 新接口
    res.data['followTotalCount']=res.data['accumulateFollowCount']
    res.data['holdTime']=res.data['averageHoldTime']
    res.data['profitAmount']=res.data['totalProfit']
    res.data['transactionNum']=res.data['tradeCount']
     return res
   },
   getLeaderListsParameter(arr){
    // copytrading/api/v2/pub/leader/leaderList
     arr = (arr||[]).map(i => {
       i.followTotalCount = i.accumulateFollowCount
       i.isBinding = i.alreadyFollowed
       i.followerCount = i.currentFollowerCount
       i.followCountLimit = i.followLimit
       i.profileUrl = i.headerUrl
       i.labelNote = i.label
       i.week3ProfitAmount = i.threeWeekProfit
       i.week3Win = i.threeWeekWinRate
       i.profitAmount = i.totalProfit
       i.positionCount = i.tradeCount
       return i
     });
     return arr
   },
   
}
export default filterFunParams;
/**
  (()=>{
    const a = ['id->userId'
                ,'loginName->nickName'
                ,'totalAsset->allAmount'
                ,'totalAssetExchange->swapAllAmount'
                ,'assetRise->quoteChange'
                ,'hasRealValidate->realName'
                ,'hasTradePassword->setTradeSecret'
                ,'vipLevel->vipGrade'
                ,'vipTop->isDistinguished'
                ,'identityType->idGenre']
    const e = a.map(i=>{
             const c = i.split('->')
             const d = 'res.data'+"['"+c[0]+"']"+ "=" +'res.data'+"['"+c[1]+"']"
        return d
        });e.map(i=>console.info(i))
 })()
 */



// WEBPACK FOOTER //
// ./src/assets/js/newApiPramas.js